import { render, staticRenderFns } from "./IfPropertyComponent.vue?vue&type=template&id=2e49d87b&"
import script from "./IfPropertyComponent.vue?vue&type=script&lang=js&"
export * from "./IfPropertyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nsierrar/Projects/PlentyMarkets/Repo-GitHub/MultiContentWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e49d87b')) {
      api.createRecord('2e49d87b', component.options)
    } else {
      api.reload('2e49d87b', component.options)
    }
    module.hot.accept("./IfPropertyComponent.vue?vue&type=template&id=2e49d87b&", function () {
      api.rerender('2e49d87b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/IfPropertyComponent.vue"
export default component.exports